import React, { useState, useEffect } from 'react';
import { Modal, Button, Icon, Radio, Spin } from 'antd';
import styled from 'styled-components';
import moment from 'moment';
import { GetMeetingAttendingTypes, GetServiceSchedules } from '../../infra/requests/ScheduleRequests';
import MeetingOptionsFields from './MeetingOptionsFields';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

/**
 * Marcação de uma reunião num dia do calendário. Os noivos escolhem
 * primeiro o tipo de atendimento e o idioma; só depois aparecem as horas
 * dos organizadores que fazem esse tipo nesse idioma.
 */
let ServiceSchedulesModal = ({ openModal, closeModal, onSubmit, onNoResources, onReroute, loading, initialValues, translate, activeLanguage }) => {

  const [attendingTypes, setAttendingTypes] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(false);
  const [attendingType, setAttendingType] = useState(null);
  const [language, setLanguage] = useState(null);
  const [services, setServices] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const [noResources, setNoResources] = useState(false);
  const [loadingServices, setLoadingServices] = useState(false);
  const [service, setService] = useState(null);

  useEffect(() => {
    if (!openModal) return;
    getAttendingTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  useEffect(() => {
    getServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attendingType, language]);

  const getAttendingTypes = async () => {
    setLoadingTypes(true);
    const result = await GetMeetingAttendingTypes();
    setAttendingTypes(result?.success && result?.data ? result.data : []);
    setLoadingTypes(false);
  };

  const getServices = async () => {
    setService(null);
    setServices([]);
    setShowWarning(false);
    setNoResources(false);
    if (!attendingType || !language || !initialValues?.date) return;

    setLoadingServices(true);
    const result = await GetServiceSchedules({
      date: initialValues.date,
      attendingType,
      language
    });
    setLoadingServices(false);

    if (result?.success) {
      setServices(result?.data?.scheduleServices || []);
      setShowWarning(result?.data?.showOrganizerWarning || false);
    } else if (result?.message === 'NOT_AUTHORIZED_REROUTE') {
      onReroute();
    } else {
      setNoResources(true);
    }
  };

  return (
    <Modal
      visible={openModal}
      title={translate('SCHEDULE_SERVICES_AVAILABLE')}
      maskClosable
      onCancel={closeModal}
      footer={[
        <Button
          key='cancel'
          onClick={() => closeModal()}
        >
          {translate('CANCEL')}
        </Button>,
        <Button
          key='submit'
          loading={loading}
          type='primary'
          disabled={!service || !attendingType || !language}
          onClick={() => onSubmit({
            date: initialValues?.date,
            // Chave composta organizador|hora: as horas disponíveis são
            // geradas da configuração e não têm id próprio.
            organizer: service ? service.split('|')[0] : null,
            startTime: service ? service.split('|')[1] : null,
            attendingType,
            language
          })}
        >
          {translate('SAVE')}
        </Button>
      ]}
    >
      {initialValues && <ModalContent>
        <p><b>{translate('DATE')}:</b> {moment.utc(initialValues.date).format('DD/MM/YYYY')}</p>

        {loadingTypes
          ? <Spin />
          : <MeetingOptionsFields
            attendingTypes={attendingTypes}
            attendingType={attendingType}
            language={language}
            disabled={loading}
            onChangeAttendingType={setAttendingType}
            onChangeLanguage={setLanguage}
            translate={translate}
            activeLanguage={activeLanguage}
          />}

        {(!attendingType || !language)
          ? <span>{translate('SELECT_MEETING_OPTIONS')}</span>
          : loadingServices
            ? <Spin />
            : noResources
              ? <React.Fragment>
                <span>{translate('NO_SERVICE_SCHEDULES_FOR_OPTIONS')}</span>
                {onNoResources && <Button
                  type='link'
                  style={{ padding: 0, alignSelf: 'flex-start' }}
                  onClick={() => onNoResources()}>
                  {translate('NOTIFY_NO_SERVICE_SCHEDULES')}
                </Button>}
              </React.Fragment>
              : <React.Fragment>
                <span>{translate('LISBON_TIME_SCHEDULES')}</span>
                <Radio.Group onChange={(event) => setService(event?.target?.value)} value={service}>
                  {services.map(m => <Radio key={m._id} value={m._id}>{m?.time} ({m?.user?.name})</Radio>)}
                </Radio.Group>
              </React.Fragment>}

        {showWarning && <p style={{ paddingTop: 10 }}>
          <Icon style={{ marginRight: 5 }} type="warning" />
          <b style={{ marginRight: 5 }}>{translate('ATTENTION')}:</b>
          {translate('NO_SERVICE_SCHEDULES_WEDDING_ORGANIZER')}
        </p>}
      </ModalContent>}
    </Modal>
  );
};

export default ServiceSchedulesModal;
